/**
 * Builds the login QR payload `{"id":..,"secure":".."}` for an employee.
 *
 * Backend endpoints return `qrCode` in different shapes:
 * - `GET /companies/{id}/users` -> object `{ id, secure }`
 * - `POST /companies/{id}/add-multiple-users` -> bare secure string
 * - delivery endpoints -> JSON string `{"id":..,"secure":".."}`
 *
 * Wrapping the object / JSON string again produces a nested `secure`
 * that the QR login (`JSON.parse(code).secure`) cannot use.
 */
export function employeeQrValue(employee) {
  let qrCode = employee?.qrCode;

  if (typeof qrCode === "string" && qrCode.trim().startsWith("{")) {
    try {
      qrCode = JSON.parse(qrCode);
    } catch (e) {
      // not JSON — treat as a bare secure string
    }
  }

  const secure = qrCode && typeof qrCode === "object" ? qrCode.secure : qrCode;

  return JSON.stringify({ id: employee?.id, secure });
}
